import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Product/ConfigurableProduct/configurableProduct.component"
    ).then((module) => ({
        default: module.ConfigurableProductComponent
    }))
);
